module.exports = __webpack_public_path__ + "static/img/edge2.6bedb79b.png";